<ion-content class="ion-no-padding">
  <form class="lead-form model-container" [formGroup]="leadForm" *ngIf="leadForm">
    <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
      <ion-toolbar class="header-first-toolbar">
        <ion-title class="text-start ion-no-padding title-blue"><span *ngIf="!editLeadId">Create New</span><span
            *ngIf="editLeadId">Edit</span> Lead (DMC)</ion-title>
        <ion-buttons slot="end" class="ion-no-margin">

          <ion-button *ngIf="!editLeadId" class="filled-blue-btn" (click)="saveAndNew()">
            Save & New
          </ion-button>
          <ion-button class="filled-blue-btn" (click)="onSubmit()">
            Save
          </ion-button>
          <ion-button (click)="closeModal()" class="unfilled-gray-btn">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <div class="model-content">
      <div class="dashed-line"></div>
      <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Lead Details</ion-title>

      <div class="form-container ion-padding-horizontal toggle-visibility">

        <div class="row">
          <div class="col-4">
            <div class="input-container">
              <label for="phone" class="label">Phone Number*</label>
              <div
                [ngClass]="{ 'invalid-input': leadForm.get('phoneNumber')?.invalid && leadForm.get('phoneNumber')?.touched }">
                <app-phone-country-input formControlName="phoneNumber"
                  (blur)="searchExistingPerson($event)"></app-phone-country-input>
                <div class="container-list-container" *ngIf="personsFromContact.length">
                  <div class="list-item" *ngFor="let person of personsFromContact"
                    (click)="personFromContactSelected(person)">
                    <p class="text">{{person.firstName}} {{person.lastName}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-4">
            <div class="input-container">
              <label for="phone" class="label">Alternate Phone Number</label>
              <div
                [ngClass]="{ 'invalid-input': leadForm.get('alternativePhoneNumber')?.invalid && leadForm.get('alternativePhoneNumber')?.touched }">
                <app-phone-country-input formControlName="alternativePhoneNumber"></app-phone-country-input>
              </div>
              <div
                *ngIf="leadForm.get('alternativePhoneNumber')?.hasError('notSameAsPhoneNumber') && leadForm.get('alternativePhoneNumber')?.touched">
                <span class="warning-message">Cannot be the same as Phone Number</span>
              </div>
            </div>
          </div>

          <div class="col-4">
            <div class="input-container">
              <label for="phone" class="label">Company Name*</label>
              <div
                [ngClass]="{ 'invalid-input': leadForm.get('companyName')?.invalid && leadForm.get('companyName')?.touched }">
                <input type="text" class="input" placeholder="Company Name" formControlName="companyName">
              </div>
            </div>
          </div>

          <div class="col-4">
            <div class="input-container">
              <label for="first-name" class="label">First Name*</label>
              <div
                [ngClass]="{ 'invalid-input': leadForm.get('firstNameWithSalutation')?.invalid && leadForm.get('firstNameWithSalutation')?.touched }">
                <app-first-name-salutation formControlName="firstNameWithSalutation"
                  [maxLength]="50"></app-first-name-salutation>
              </div>
            </div>
          </div>

          <div class="col-4">
            <div class="input-container">
              <label for="last-name" class="label">Last Name</label>
              <div
                [ngClass]="{ 'invalid-input': leadForm.get('lastName')?.invalid && leadForm.get('lastName')?.touched }">
                <input appRestrictSpecialChars appRestrictNumbers class="input-text input" type="text" id="last-name"
                  placeholder="Enter Last Name" formControlName="lastName" [appMaxLength]="50">
              </div>
            </div>
          </div>

          <div class="col-4">
            <div class="input-container">
              <label for="email" class="label">Email ID *</label>
              <div [ngClass]="{ 'invalid-input': leadForm.get('email')?.invalid && leadForm.get('email')?.touched }">
                <input class="input-text input" type="text" id="email" placeholder="Ex: someone@mail.com"
                  formControlName="email" [appMaxLength]="64">
              </div>
            </div>
          </div>

          <div class="col-4">
            <div class="input-container">
              <label class="label" for="Ownership">Assign Ownership*</label>
              <div
                [ngClass]="{ 'invalid-input': leadForm.get('ownership')?.invalid && leadForm.get('ownership')?.touched }">
                <app-assigning-users-input formControlName="ownership"
                  (emitUserDetails)="assignSelectedUser($event)"></app-assigning-users-input>
              </div>
            </div>
          </div>

          <div class="col-4">
            <div class="input-container">
              <label for="phone" class="label">Lead Source*</label>
              <div [ngClass]="{ 'invalid-input': leadForm.get('source')?.invalid && leadForm.get('source')?.touched }">
                <select name="" id="" class="input" formControlName="source">
                  <option value="" hidden>-- select an option --</option>
                  <option *ngFor="let item of leadSource" [value]="item.name">{{item.name}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="input-container">
              <label class="label" for="lead status">Lead Status</label>
              <div>
                <select name="" id="" class="input" formControlName="status">
                  <option value="" hidden>-- select an option --</option>
                  <option *ngFor="let item of leadStatus" [ngClass]="{'d-none': item.disabled}" [value]="item.name">
                    {{item.name}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="input-container">
              <label class="label">Lead Priority</label>
              <div>
                <select name="" id="" class="input" formControlName="priority">
                  <option value="" hidden>-- select an option --</option>
                  <option *ngFor="let item of leadPriority" [value]="item.name">{{item.name}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <!-- Lead service -->
        <div class="row">
          <div class="col">
            <div class=" input-container service-container w-100">
              <div class="d-flex justify-content-between align-items-center">
                <label for="" class="label">Select Service Types*<span class="text-danger warning-message ms-2"
                    *ngIf="leadForm.get('travelServices')?.invalid && leadForm.get('travelServices')?.touched">Select at
                    least 1 service</span></label>

                <ion-button class="clear-service-btn" (click)="clearServices()"
                  [disabled]="disableServiceType || leadForm.get('travelServices')?.value?.length === 0">Clear
                  Services</ion-button>
              </div>
              <app-dmc-travel-services-input [disableServiceType]="disableServiceType" formControlName="travelServices"
                [invalidInput]="leadForm.get('travelServices')?.invalid && leadForm.get('travelServices')?.touched"></app-dmc-travel-services-input>
            </div>
          </div>
        </div>

        <!-- Lead notes -->
        <div class="row">
          <div class="col-12">
            <div class="input-container">
              <label for="notes" class="label">Notes</label>
              <div>
                <textarea class="input-text input" rows="4" id="notes" placeholder="Add lead notes here"
                  formControlName="leadNote" [appMaxLength]="350"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dashed-line mt-3"></div>

    </div>


    <!-- Save button -->
      <div class="model-footer ion-padding-horizontal bg-light-gray">
        <ion-button class="filled-blue-btn" type="submit" (click)="saveAndNext()">Next</ion-button>
      </div>

  </form>
</ion-content>